import { FinishAuthorizedCommunication } from 'domain/usecases/surgical-pendency/finish-authorized-communication'
import { SurgicalPendencyRepository } from 'repository/interfaces/surgical-pendency-repository'

export class RemoteFinishAuthorizedCommunication
  implements FinishAuthorizedCommunication
{
  constructor(
    private readonly surgicalPendencyRepository: SurgicalPendencyRepository
  ) {}

  answer(
    params: FinishAuthorizedCommunication.Params
  ): Promise<FinishAuthorizedCommunication.Model> {
    return this.surgicalPendencyRepository.finishAuthorizedCommunication(params)
  }
}
